module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/userIcon@2x-c31d4af6df5a25c3631e5ff4e39413be.png";